import productCarrousel from "../components/productCarrousel";
import homeView from "../views/homeView";
export function homeViewLogic(store, mainContent) {
    viewRendering(mainContent);
    loadCarrousselProducts(store);
}
//view rendering
function viewRendering(mainContent) {
    mainContent.innerHTML = homeView();
}
//load store products inside the carrousel according to price discounts
function loadCarrousselProducts(store) {
    var productCarrouselContainer = document.getElementById("product-carrousel-container");
    var discountProducts = filterProductsByDiscount(store.showCatalog());
    discountProducts.forEach(function (product) {
        productCarrouselContainer.innerHTML += productCarrousel(product);
    });
}
function filterProductsByDiscount(productList) {
    return productList.filter(function (product) { return product.discount > 0; });
}
